export const resumenTest = {
    "Estimado Sr.(a)": "Test Name",
    "Descripción": "NUEVO - DODGE - ATTITUDE SE L3 IMO AUT 4 ABS CA CE TELA SM SQ CB - 2023",
    "Precio del Vehículo": "$435,000.00",
    "Accesorios": "$0.00",
    "Precio Total": "$435,000.00",
    "Suma a Asegurar": "$435,000.00",
    "Enganche": "$200,000.00",
    "Comisión por Apertura": "$7,050.00",
    "Seguro Multianual": "$174,486.44",
    "Gastos de Originación": "$2,500.00",
    "Total Pago Inicial": "$209,550.00",
    "Importe del Vehículo a Financiar": "$235,000.00",
    "Pago Mensual Base": "$7,626.16",
    "Pago Mensual Total": "$12,155.72"
}

export const detalleTest = [
    [
        "Cuota",
        "Capital Inicial",
        "Interes",
        "IVA",
        "Capital Vehículo",
        "Capital Final",
        "Pago Mensual Base",
        "Seguro",
        "GPS",
        "Gestorias",
        "IVA",
        "Pago Mensual Servicios",
        "Pago Mensual Total"
    ],
    [
        1,
        "$235,000.00",
        "$5,091.67",
        "$814.67",
        "$1,719.83",
        "$233,280.17",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        2,
        "$233,280.17",
        "$5,054.40",
        "$808.70",
        "$1,763.05",
        "$231,517.12",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        3,
        "$231,517.12",
        "$5,016.20",
        "$802.59",
        "$1,807.36",
        "$229,709.76",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        4,
        "$229,709.76",
        "$4,977.04",
        "$796.33",
        "$1,852.79",
        "$227,856.97",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        5,
        "$227,856.97",
        "$4,936.90",
        "$789.90",
        "$1,899.35",
        "$225,957.62",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        6,
        "$225,957.62",
        "$4,895.75",
        "$783.32",
        "$1,947.09",
        "$224,010.53",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        7,
        "$224,010.53",
        "$4,853.56",
        "$776.57",
        "$1,996.03",
        "$222,014.50",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        8,
        "$222,014.50",
        "$4,810.31",
        "$769.65",
        "$2,046.20",
        "$219,968.30",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        9,
        "$219,968.30",
        "$4,765.98",
        "$762.56",
        "$2,097.62",
        "$217,870.68",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        10,
        "$217,870.68",
        "$4,720.53",
        "$755.29",
        "$2,150.34",
        "$215,720.34",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        11,
        "$215,720.34",
        "$4,673.94",
        "$747.83",
        "$2,204.39",
        "$213,515.95",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        12,
        "$213,515.95",
        "$4,626.18",
        "$740.19",
        "$2,259.79",
        "$211,256.16",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        13,
        "$211,256.16",
        "$4,577.22",
        "$732.35",
        "$2,316.59",
        "$208,939.57",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        14,
        "$208,939.57",
        "$4,527.02",
        "$724.32",
        "$2,374.81",
        "$206,564.76",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        15,
        "$206,564.76",
        "$4,475.57",
        "$716.09",
        "$2,434.50",
        "$204,130.26",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        16,
        "$204,130.26",
        "$4,422.82",
        "$707.65",
        "$2,495.69",
        "$201,634.57",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        17,
        "$201,634.57",
        "$4,368.75",
        "$699.00",
        "$2,558.41",
        "$199,076.16",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        18,
        "$199,076.16",
        "$4,313.32",
        "$690.13",
        "$2,622.71",
        "$196,453.45",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        19,
        "$196,453.45",
        "$4,256.49",
        "$681.04",
        "$2,688.63",
        "$193,764.82",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        20,
        "$193,764.82",
        "$4,198.24",
        "$671.72",
        "$2,756.20",
        "$191,008.62",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        21,
        "$191,008.62",
        "$4,138.52",
        "$662.16",
        "$2,825.48",
        "$188,183.14",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        22,
        "$188,183.14",
        "$4,077.30",
        "$652.37",
        "$2,896.49",
        "$185,286.65",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        23,
        "$185,286.65",
        "$4,014.54",
        "$642.33",
        "$2,969.29",
        "$182,317.36",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        24,
        "$182,317.36",
        "$3,950.21",
        "$632.03",
        "$3,043.92",
        "$179,273.44",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        25,
        "$179,273.44",
        "$3,884.26",
        "$621.48",
        "$3,120.42",
        "$176,153.02",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        26,
        "$176,153.02",
        "$3,816.65",
        "$610.66",
        "$3,198.85",
        "$172,954.18",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        27,
        "$172,954.18",
        "$3,747.34",
        "$599.57",
        "$3,279.24",
        "$169,674.93",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        28,
        "$169,674.93",
        "$3,676.29",
        "$588.21",
        "$3,361.66",
        "$166,313.27",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        29,
        "$166,313.27",
        "$3,603.45",
        "$576.55",
        "$3,446.15",
        "$162,867.12",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        30,
        "$162,867.12",
        "$3,528.79",
        "$564.61",
        "$3,532.77",
        "$159,334.35",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        31,
        "$159,334.35",
        "$3,452.24",
        "$552.36",
        "$3,621.56",
        "$155,712.80",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        32,
        "$155,712.80",
        "$3,373.78",
        "$539.80",
        "$3,712.58",
        "$152,000.22",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        33,
        "$152,000.22",
        "$3,293.34",
        "$526.93",
        "$3,805.89",
        "$148,194.33",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        34,
        "$148,194.33",
        "$3,210.88",
        "$513.74",
        "$3,901.54",
        "$144,292.79",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        35,
        "$144,292.79",
        "$3,126.34",
        "$500.21",
        "$3,999.60",
        "$140,293.19",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        36,
        "$140,293.19",
        "$3,039.69",
        "$486.35",
        "$4,100.12",
        "$136,193.06",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        37,
        "$136,193.06",
        "$2,950.85",
        "$472.14",
        "$4,203.17",
        "$131,989.89",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        38,
        "$131,989.89",
        "$2,859.78",
        "$457.56",
        "$4,308.81",
        "$127,681.08",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        39,
        "$127,681.08",
        "$2,766.42",
        "$442.63",
        "$4,417.11",
        "$123,263.97",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        40,
        "$123,263.97",
        "$2,670.72",
        "$427.32",
        "$4,528.13",
        "$118,735.84",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        41,
        "$118,735.84",
        "$2,572.61",
        "$411.62",
        "$4,641.93",
        "$114,093.91",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        42,
        "$114,093.91",
        "$2,472.03",
        "$395.53",
        "$4,758.60",
        "$109,335.31",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        43,
        "$109,335.31",
        "$2,368.93",
        "$379.03",
        "$4,878.20",
        "$104,457.11",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        44,
        "$104,457.11",
        "$2,263.24",
        "$362.12",
        "$5,000.80",
        "$99,456.31",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        45,
        "$99,456.31",
        "$2,154.89",
        "$344.78",
        "$5,126.49",
        "$94,329.82",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        46,
        "$94,329.82",
        "$2,043.81",
        "$327.01",
        "$5,255.34",
        "$89,074.48",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        47,
        "$89,074.48",
        "$1,929.95",
        "$308.79",
        "$5,387.42",
        "$83,687.06",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        48,
        "$83,687.06",
        "$1,813.22",
        "$290.12",
        "$5,522.82",
        "$78,164.23",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        49,
        "$78,164.23",
        "$1,693.56",
        "$270.97",
        "$5,661.63",
        "$72,502.60",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        50,
        "$72,502.60",
        "$1,570.89",
        "$251.34",
        "$5,803.93",
        "$66,698.67",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        51,
        "$66,698.67",
        "$1,445.14",
        "$231.22",
        "$5,949.80",
        "$60,748.87",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        52,
        "$60,748.87",
        "$1,316.23",
        "$210.60",
        "$6,099.34",
        "$54,649.54",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        53,
        "$54,649.54",
        "$1,184.07",
        "$189.45",
        "$6,252.63",
        "$48,396.90",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        54,
        "$48,396.90",
        "$1,048.60",
        "$167.78",
        "$6,409.78",
        "$41,987.12",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        55,
        "$41,987.12",
        "$909.72",
        "$145.56",
        "$6,570.88",
        "$35,416.23",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        56,
        "$35,416.23",
        "$767.35",
        "$122.78",
        "$6,736.03",
        "$28,680.20",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        57,
        "$28,680.20",
        "$621.40",
        "$99.42",
        "$6,905.33",
        "$21,774.87",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        58,
        "$21,774.87",
        "$471.79",
        "$75.49",
        "$7,078.88",
        "$14,695.99",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        59,
        "$14,695.99",
        "$318.41",
        "$50.95",
        "$7,256.80",
        "$7,439.19",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        60,
        "$7,439.19",
        "$161.18",
        "$25.79",
        "$7,439.19",
        "$0.00",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        51,
        "$66,698.67",
        "$1,445.14",
        "$231.22",
        "$5,949.80",
        "$60,748.87",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        52,
        "$60,748.87",
        "$1,316.23",
        "$210.60",
        "$6,099.34",
        "$54,649.54",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        53,
        "$54,649.54",
        "$1,184.07",
        "$189.45",
        "$6,252.63",
        "$48,396.90",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        54,
        "$48,396.90",
        "$1,048.60",
        "$167.78",
        "$6,409.78",
        "$41,987.12",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        55,
        "$41,987.12",
        "$909.72",
        "$145.56",
        "$6,570.88",
        "$35,416.23",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        56,
        "$35,416.23",
        "$767.35",
        "$122.78",
        "$6,736.03",
        "$28,680.20",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        57,
        "$28,680.20",
        "$621.40",
        "$99.42",
        "$6,905.33",
        "$21,774.87",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        58,
        "$21,774.87",
        "$471.79",
        "$75.49",
        "$7,078.88",
        "$14,695.99",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        59,
        "$14,695.99",
        "$318.41",
        "$50.95",
        "$7,256.80",
        "$7,439.19",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        60,
        "$7,439.19",
        "$161.18",
        "$25.79",
        "$7,439.19",
        "$0.00",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        59,
        "$14,695.99",
        "$318.41",
        "$50.95",
        "$7,256.80",
        "$7,439.19",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ],
    [
        60,
        "$7,439.19",
        "$161.18",
        "$25.79",
        "$7,439.19",
        "$0.00",
        "$7,626.16",
        "$2,935.16",
        "$550.00",
        "$419.63",
        "$624.77",
        "$4,529.56",
        "$12,155.72"
    ]
]

export const detalleObj = [
    {
        "Cuota": 1,
        "Capital Inicial": '$235,000.00',
        "Interes": '$5,091.67',
        "IVA": '$814.67',
        "Capital Vehículo": '$1,719.83',
        "Capital Final": '$233,280.17',
        "Pago Mensual Base": '7 $7,626.16',
        "Seguro": '$2,935.16',
        "GPS": '$550.00',
        "Gestorias": '$419.63',
        "IVA": '$624.77',
        "Pago Mensual Servicios": '$4,529.56',
        "Pago Mensual Total": '$12,155.72'
    },
    {
        "Cuota": 2,
        "Capital Inicial": '$235,000.00',
        "Interes": '$5,091.67',
        "IVA": '$814.67',
        "Capital Vehículo": '$1,719.83',
        "Capital Final": '$233,280.17',
        "Pago Mensual Base": '7 $7,626.16',
        "Seguro": '$2,935.16',
        "GPS": '$550.00',
        "Gestorias": '$419.63',
        "IVA": '$624.77',
        "Pago Mensual Servicios": '$4,529.56',
        "Pago Mensual Total": '$12,155.72'
    },
    {
        "Cuota": 3,
        "Capital Inicial": '$235,000.00',
        "Interes": '$5,091.67',
        "IVA": '$814.67',
        "Capital Vehículo": '$1,719.83',
        "Capital Final": '$233,280.17',
        "Pago Mensual Base": '7 $7,626.16',
        "Seguro": '$2,935.16',
        "GPS": '$550.00',
        "Gestorias": '$419.63',
        "IVA": '$624.77',
        "Pago Mensual Servicios": '$4,529.56',
        "Pago Mensual Total": '$12,155.72'
    }
]